@if (isSmallView) {
  <ldw-document-toolbar-mobile
    [showBookmark]="showBookmark"
    [document]="document"
    [allowStatusChange]="allowStatusChange"
    [isReadOnly]="isReadOnly"
    (closeSelected)="close()"
    (statusChanged)="statusHasChanged($event)"
  ></ldw-document-toolbar-mobile>
}


@if (isDefaultView) {
  <ldw-document-toolbar-regular
    [showBookmark]="showBookmark"
    [document]="document"
    [allowStatusChange]="allowStatusChange"
    [isReadOnly]="isReadOnly"
    (closeSelected)="close()"
    (statusChanged)="statusHasChanged($event)"
  ></ldw-document-toolbar-regular>
}
